/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createSackurTetrode } from '../../factoriesAny.js';
export var sackurTetrodeDependencies = {
  BigNumberDependencies,
  createSackurTetrode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSackurTetrode.generated.js
// module id = 996U
// module chunks = 3